/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Cv_Check_No_Reviews_LeftInputs */

const en_cv_check_no_reviews_left = /** @type {(inputs: Cv_Check_No_Reviews_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have used all ${i?.limit} checks in the last 6 months.`)
};

const de_cv_check_no_reviews_left = /** @type {(inputs: Cv_Check_No_Reviews_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast alle ${i?.limit} Checks in den letzten 6 Monaten aufgebraucht.`)
};

/**
* | output |
* | --- |
* | "You have used all {limit} checks in the last 6 months." |
*
* @param {Cv_Check_No_Reviews_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_no_reviews_left = /** @type {((inputs: Cv_Check_No_Reviews_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_No_Reviews_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_no_reviews_left(inputs)
	return en_cv_check_no_reviews_left(inputs)
});